require('./faq.scss');
import {submitMailCta} from "../utils";

$(() => {
    submitMailCta();
    // Your code here
});